export const toToday = () => {
  const d = new Date()
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
}

export const toPeriodo = (dateStr) => {
  if (!dateStr) return ''
  const [year, month] = dateStr.split('-')
  return `${year}${month}`
}

export const formatPeriodo = (yyyymm) => {
  const s = String(yyyymm ?? '')
  if (s.length < 6) return s
  return `${s.substring(4, 6)}/${s.substring(0, 4)}`
}

export const formatPeriodoInforme = (periodo) => {
  const raw = String(periodo ?? '').trim()
  if (!raw) return ''

  const yyyymm = raw.match(/^(\d{4})(\d{2})$/)
  if (yyyymm) return `${yyyymm[1]}/${yyyymm[2]}`

  const yyyySepMm = raw.match(/^(\d{4})[/-](\d{2})$/)
  if (yyyySepMm) return `${yyyySepMm[1]}/${yyyySepMm[2]}`

  const mmSepYyyy = raw.match(/^(\d{2})[/-](\d{4})$/)
  if (mmSepYyyy) return `${mmSepYyyy[2]}/${mmSepYyyy[1]}`

  const digits = raw.replace(/\D/g, '')
  if (digits.length >= 6) {
    return `${digits.substring(0, 4)}/${digits.substring(4, 6)}`
  }

  return raw
}
